import React from 'react';
import PropTypes from 'prop-types';
import ButtonLoader from '../../shared/components/auth/ButtonLoader';
import { Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { signOut } from '../../actions/auth';

class SignOutButton extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    icon: PropTypes.node
  };

  static defaultProps = {
    children: <span>Sign Out</span>,
    icon: <Glyphicon glyph='log-out' />
  };

  handleClick = async () => {
    await this.props.dispatch(signOut());
  }

  render () {
    const {
      isLoading,
      isSignedIn,
      icon,
      ...restProps
    } = this.props;

    const disabled = !isSignedIn;

    return (
      <ButtonLoader
        loading={isLoading}
        icon={icon}
        disabled={disabled}
        className='sign-out-submit'
        onClick={this.handleClick}
        {...restProps} />
    );
  }
}

export default connect(({auth: {isSignedIn, isLoading}}) => ({isSignedIn, isLoading}))(SignOutButton);



// WEBPACK FOOTER //
// ./src/auth/components/sign-out-button.js